import { render, staticRenderFns } from "./YamlProperties.vue?vue&type=template&id=cb18e28e&scoped=true"
import script from "./YamlProperties.vue?vue&type=script&lang=js"
export * from "./YamlProperties.vue?vue&type=script&lang=js"
import style0 from "./YamlProperties.vue?vue&type=style&index=0&id=cb18e28e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb18e28e",
  null
  
)

export default component.exports